export default {
  props: {
    counter: {
      type: Boolean,
      default: false
    },
    counterValue: {
      type: Number,
      default: 250
    },
    required: {
      type: Boolean
    },
    rules: {
      type: Array
    },
    errorMessages: {
      type: [String, Array]
    }
  },
  data() {
    return {
      errors: [],
      isValid: false
    }
  },
  computed: {
    hasError() {
      console.log(this.errors)
      return this.errors.length > 0;
    },
    characters() {
      return this.value ? this.value.length : 0;
    },
    charactersRem() {
      return this.value ? this.counterValue - this.characters : 
        this.counterValue;
    }
  },
  mounted() {
    this.validate(this.value, true);
  },
  methods: {
    validateRules(v) {
      let errors = [];

      if (this.rules) { 
        this.rules.forEach(rule => {
          if (rule(v) !== true) {
            errors.push(rule(v));
          }
        })
      }

      if (this.required && !v) {
        errors.push('This field is required');
      }

      if (this.counter) {
        if (this.charactersRem < 0) {
          errors.push('character limit reached');
          let newVal = v.substring(0, this.counterValue + 1);
          this.$emit('input', newVal);
        }
      }
      return errors;
    },
    validate(v, initial) {
      if (initial) {
        let tempErrors = this.validateRules(v);
        this.isValid = tempErrors.length === 0;
        this.$emit('valid-update', tempErrors.length === 0);
      } else {
        let newErrors = this.validateRules(v);
        this.errors = newErrors;
        this.$emit('update:errorMessages', newErrors);
        this.$emit('error-update', newErrors);
        this.isValid = newErrors.length === 0;
        this.$emit('valid-update', newErrors.length === 0);
      }
    }
  }
}